import React from 'react'

import {Action} from '../modules/events'

export const DispatchContext = React.createContext((a:Action)=>{})